import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {NavService} from '../../../services/nav.service';
import {ProgressModel} from '../../../services/models/progress.model';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    @Input() isSaving = false;
    @Input() saveButton = false;
    @Input() backButton = false;
    @Input() currentPage = null;
    @Input() progress: ProgressModel = null;
    @Input() level = null;
    @Input() forAdmin = false;
    @Output() saveEvent = new EventEmitter();

    isMenuDisplayed = false;

    constructor(
        private nav: NavService,
        public userService: UserService,
    ) {
    }

    ngOnInit() {
       this.isMenuDisplayed = this.userService.userInfo.client_id !== 131;
    }

    navigateTo(page: string) {
        this.nav.navigate([page]);
    }

    goBack() {
        this.nav.back();
    }

    onSave() {
        this.saveEvent.emit();
    }
}
